<template>
  <div class="project" >
    <div class="container">
      <!-- <h3 class="project-title">НАШИ ПРОЕКТЫ</h3> -->
      <div class="project__content">
        <div class="project__content-items">
          <CentrisCardsHover
            v-for="(project, index) in projectContent.slice(0, 4)"
            :key="index"
            :project="project"
          ></CentrisCardsHover>
        </div>
        <div class="project__content-items" :class="{ hide: !hideCards }">
          <CentrisCardsHover
            v-for="(project, index) in projectContent.slice(4, 8)"
            :key="index"
            :project="project"
          ></CentrisCardsHover>
        </div>
        <button class="project__content-btn" @click="showContent()" :class="{close: hideCards}">
          СМОТРЕТЬ ЕЩЕ
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import CentrisCardsHover from "@/components/CentrisCardsHover";
export default {
  components: {
    CentrisCardsHover,
  },
  data() {
    return {
      hideCards: false,
      viewportWidth: window.innerWidth,
    };
  },
  methods: {
    showContent() {
      this.hideCards = true;
    },
    hideBtn(){
      if (this.hideCards = true) {
        this.hideCards = false;
      }
    }
  },
  mounted() {
    this.hideBtn()
  },
  computed: {
    projectContent() {
      return this.$store.getters.getProjectContent();
    },
  },
  watch: {},
};
</script>
<style lang="scss">
@import "@/assets/scss/grid/grid";
.project {
  width: 100%;
  max-width: 1700px;
  margin: 0 auto;
  background: #19191b;
  @include adaptivPaddinglg(0, 0, 122, 100, 0, 0, 85, 100);
  position: relative;
  @media (max-width: 1800px) {
    max-width: 1600px;
    width: 100%;
  }
  @media (max-width: 1700px) {
    max-width: 1500px;
    width: 100%;
  }
  @media (max-width: 1600px) {
    max-width: 1400px;
    width: 100%;
  }
  @media (max-width: 1500px) {
    max-width: 1300px;
    width: 100%;
  }
  @media (max-width: 1400px) {
    max-width: 1100px;
    width: 100%;
  }
  @media (max-width: 1200px) {
    max-width: 1100px;
    width: 100%;
  }
  @media (max-width: 768px) {
    min-height: 300px;
    overflow: hidden;
  }
  &-title {
    @include adaptiv-fontlg(48, 28);
    @include adaptiv-lineHeightlg(52, 32);
    font-family: "Helvetica-bold";
    text-transform: uppercase;
    font-weight: normal;
    color: #fff;
    text-align: center;
    @include adaptivMarginlg(0, 0, 0, 80, 0, 0, 0, 50);
    @media (min-width: 1921px) {
      font-size: 60px;
    }
    @media (max-width: 768px) {
      @include adaptiv-fontmd(35, 22);
      @include adaptiv-lineHeightmd(36, 29);
    }
  }
}
</style>